import axios from 'axios'
const client = axios.create();

export const FavoritesApi = {
    async getFavorites(data) {
        return client.get(Routing.generate('get_favorite_books_pagination', data));
    }
}